<!-- Template for the action button that parent component can render -->
<ng-template #actionButton>
  <iris-button
    id="pendo-payment-info-submission"
    data-test="button-save"
    [type]="IrisButtonTypes.PRIMARY"
    [typeAttribute]="IrisButtonTypeAttributeOptions.SUBMIT"
    [disabled]="!allowSubmit || !!ccFormComponent?.submitting"
    (click)="submitCreditCard()"
  >
    <ng-container *ngIf="!ccFormComponent?.submitting; else spinner">
      @if (fromDirectBooking) {
        Confirm session
      } @else if (useInSessionRequest) {
        Next
      } @else {
        Submit
      }
    </ng-container>

    <ng-template #spinner>
      <mat-spinner
        class="button-spinner"
        diameter="24"
        aria-label="Submission is processing"
      ></mat-spinner>
    </ng-template>
  </iris-button>
</ng-template>

@if (fromDirectBooking) {
  <div class="preamble">
    <h1 class="iris-h1-responsive">You're nearly there</h1>
    <p class="iris-body-responsive">
      Please add your payment method for any co-pays that may be charged by your insurance.
    </p>
  </div>
} @else {
  <h2 class="iris-h2-responsive">Complete your account</h2>
  <p class="iris-body-responsive">
    We need a little more information so that you're all set for your first therapy session.
  </p>
}

<div [class.from-direct-booking]="fromDirectBooking">
  <div class="payment-wrapper">
    <h3 class="iris-h3-responsive section-label" data-test="payment-method-header-text">
      <div>
        Payment method
      </div>
    </h3>
    <p 
      class="iris-body-responsive" 
      data-test="payment-method-paragraph-text"
    >
      You can enter a credit, debit, or HSA/FSA card.
    </p>
  </div>
  <client-credit-card-add
    #ccForm
    [useInline]="true"
    [useInSessionRequest]="useInSessionRequest"
    (closeAdd)="submitFinancialAgreements()"
    [isProposeATime]="isProposeATime"
  ></client-credit-card-add>
  <div class="payment-wrapper buffer-bottom">
    <form [formGroup]="paymentForm">
      <iris-checkbox formControlName="acceptedFinancialPolicy" data-test="payment-authorization-checkbox-text">
        I agree to the
        <a class="iris-link-responsive" href="{{ financialResponsibilityAgreement }}" target="_blank">Financial Responsibility Agreement</a>,
        and authorize SonderMind to charge the payment card on file in accordance with those terms.
      </iris-checkbox>
    </form>
    <client-faq-accordion
      *ngIf="showPaymentFaq"
      [accountComplete]="false"
      [isMobile]="isMobile"
      [paymentInfoOnly]="true"
      [paymentSetupView]="true"
      [isProposeATime]="isProposeATime"
    ></client-faq-accordion>
  </div>
</div>

@if (!fromDirectBooking) {
  <iris-button-container [alignment]="IrisButtonContainerAlignments.END">
    <ng-container *ngTemplateOutlet="actionButton"></ng-container>
  </iris-button-container>
}